export default '/build/150fa981.svg'